import type { LanguageCode } from "../state/i18n";

// Languages we translate the platform into, but that have no content outside of it, e.g. on the pages we link to
export const FALLBACK_LANGUAGES = {
  ca: "es",
} as const satisfies Partial<Record<LanguageCode, LanguageCode>>;

/** Resolves a language to the closest one available outside the platform, e.g. on the pages we link to */
export const resolveFallbackLanguage = (language: LanguageCode): LanguageCode =>
  FALLBACK_LANGUAGES[language as keyof typeof FALLBACK_LANGUAGES] ?? language;
